import { parseDate } from './format.js';

const TAG = 86400000;

/**
 * Reine Berechnung fuer die Zeitachse -- bewusst ohne React, damit sie
 * unabhaengig von der Darstellung getestet werden kann.
 */
export function baueModell(events, jetzt) {
  if (!events || events.length === 0) return null;

  const starts = events.map((e) => parseDate(e.startsAt).getTime());
  const enden = events.map((e) => parseDate(e.endsAt).getTime());

  let von = Math.min(...starts, jetzt.getTime());
  let bis = Math.max(...enden, jetzt.getTime());

  // Luft an beiden Seiten, damit Balken und Jetzt-Linie nicht am Rand kleben.
  // Bei sehr kurzen Zeitraeumen mindestens ein halber Tag.
  const luft = Math.max((bis - von) * 0.06, TAG / 2);
  von -= luft;
  bis += luft;

  const spanne = bis - von;

  return {
    von: new Date(von),
    bis: new Date(bis),
    spanne,
    spuren: verteileAufSpuren(events),
    ticks: baueTicks(new Date(von), new Date(bis), spanne / TAG),
    jetztAnteil:
      jetzt.getTime() >= von && jetzt.getTime() <= bis
        ? ((jetzt.getTime() - von) / spanne) * 100
        : null,
  };
}

/**
 * Ueberlappende Events auf mehrere Zeilen verteilen. Greedy: jedes Event kommt
 * in die erste Spur, in der es kollisionsfrei passt.
 *
 * Der Zuschlag von 6 Stunden ist kein Zeitpuffer, sondern Platz fuer den
 * Titel -- zwei direkt aufeinanderfolgende Events wuerden sonst zwar nicht
 * ueberlappen, ihre Beschriftungen aber schon.
 */
export function verteileAufSpuren(events) {
  const sortiert = [...events].sort((a, b) => parseDate(a.startsAt) - parseDate(b.startsAt));
  const spuren = [];

  for (const event of sortiert) {
    const start = parseDate(event.startsAt).getTime();
    const spur = spuren.find((s) => {
      const letztes = s[s.length - 1];
      return parseDate(letztes.endsAt).getTime() + 6 * 3600000 < start;
    });

    if (spur) spur.push(event);
    else spuren.push([event]);
  }

  return spuren;
}

/**
 * Rasterlinien in einer Dichte, die zur Spannweite passt.
 */
export function baueTicks(von, bis, tage) {
  const schrittTage = tage <= 10 ? 1 : tage <= 35 ? 7 : tage <= 120 ? 14 : 30;
  const ticks = [];

  const cursor = new Date(von);
  cursor.setHours(0, 0, 0, 0);
  if (cursor < von) cursor.setDate(cursor.getDate() + 1);

  while (cursor <= bis && ticks.length < 40) {
    ticks.push(new Date(cursor));
    cursor.setDate(cursor.getDate() + schrittTage);
  }

  return ticks;
}

/** Anteil eines Zeitpunkts an der Achse, in Prozent. */
export const anteil = (datum, von, spanne) => ((datum - von) / spanne) * 100;

export const kurzDatum = (d) =>
  new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: 'short' }).format(d);
